import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreAllSalesforceUsersGetSlice } from './get';

export const coreAllSalesforceUsersReducers = combineReducers({
	get: coreAllSalesforceUsersGetSlice.asyncReducers
});

export const coreAllSalesforceUsersWatchers = combineAllWatchers([ coreAllSalesforceUsersGetSlice.asyncWatchers ]);
